import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Layers, Radio, Target, CalendarCheck2, AlarmClockOff } from "lucide-react";
import { todayStr } from "@/lib/dates";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import TaskCalendarWidget from "@/components/TaskCalendarWidget";

const KPIS = [
  { key: "total_bulk",          label: "Total Bulk Leads",  icon: Layers,         bg: "bg-slate-100",      iconColor: "text-slate-700",   to: "/leads",                tid: "kpi-total-bulk" },
  { key: "total_live",          label: "Total Live Leads",  icon: Radio,          bg: "bg-rose-100/70",    iconColor: "text-rose-600",    to: "/leads?type=live",      tid: "kpi-total-live" },
  { key: "total_opportunities", label: "Opportunities",     icon: Target,         bg: "bg-emerald-100/70", iconColor: "text-emerald-600", to: "/opportunities",        tid: "kpi-total-opps" },
  { key: "today_tasks",         label: "Today's Tasks",     icon: CalendarCheck2, bg: "bg-blue-100/70",    iconColor: "text-blue-600",    to: "/tasks",                tid: "kpi-today-tasks" },
  { key: "pending_tasks",       label: "Pending Tasks",     icon: AlarmClockOff,  bg: "bg-amber-100/70",   iconColor: "text-amber-600",   to: "/tasks?view=pending",   tid: "kpi-pending-tasks" },
];

export default function DashboardPage() {
  const { user } = useAuth();
  const kpisQ = useQuery({
    queryKey: ["dashboard", "kpis"],
    queryFn: async () => (await api.get("/dashboard/kpis", { params: { today: todayStr() } })).data,
  });
  const s = kpisQ.data || {};

  return (
    <div className="space-y-6" data-testid="dashboard-page">
      <div className="hidden lg:block">
        <p className="text-sm text-slate-500">Welcome back</p>
        <h2 className="text-3xl font-bold text-navy">
          Hello, {user?.name?.split(" ")[0] || "there"} <span className="ml-1">👋</span>
        </h2>
      </div>

      {/* Stat grid */}
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {KPIS.map((k, i) => <StatCard key={k.key} cfg={k} value={s[k.key]} delay={i * 60} />)}
      </div>

      <TaskCalendarWidget />
    </div>
  );
}

function StatCard({ cfg, value, delay }) {
  const Icon = cfg.icon;
  const label = cfg.label;
  return (
    <Link
      to={cfg.to}
      data-testid={cfg.tid}
      style={{ animationDelay: `${delay}ms` }}
      className="soft-card anim-fade-up block p-4 transition hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--brand-navy))]"
    >
      <div className={`grid h-10 w-10 place-items-center rounded-full ${cfg.bg}`}>
        <Icon className={`h-4 w-4 ${cfg.iconColor}`} />
      </div>
      <div className="mt-4 text-3xl font-black tracking-tight text-navy">
        {value ?? <span className="text-slate-300">—</span>}
      </div>
      <div className="mt-1 text-sm text-slate-500">{label}</div>
    </Link>
  );
}
